import { render } from "./InvestmentReview.vue?vue&type=template&id=c926db84"
import script from "./InvestmentReview.vue?vue&type=script&lang=js"
export * from "./InvestmentReview.vue?vue&type=script&lang=js"
script.render = render

export default script